import { Center, Loader, LoadingOverlay, Stack, Text } from '@mantine/core';
import { memo } from 'react';
import { FONT_WEIGHT } from 'src/config/theme';
import { useAppColorScheme } from 'src/providers/color-scheme/appColorScheme.context';

export const ContentLoader = memo(function ContentLoader(props: { message: string }) {
  const { message } = props;
  return (
    <Center py="xl" style={{ width: '100%' }} h="100vh">
      <Stack
        gap="xl"
        align="center"
        justify="center"
        style={{
          padding: '1.5rem 2rem'
        }}
      >
        <LoaderWithMsg message={message} />
      </Stack>
    </Center>
  );
});
export const OverlayLoader = memo(function OverlayLoader(props: {
  message: string;
  opacity?: number;
}) {
  const { message, opacity } = props;

  return (
    <Center py="xl" style={{ width: '100%' }} h="100vh">
      <Stack
        gap="xl"
        align="center"
        justify="center"
        style={{
          padding: '1.5rem 2rem'
        }}
      >
        <LoadingOverlay
          visible
          overlayProps={{
            opacity: opacity ?? undefined,
            blur: opacity === 1 ? 0.2 : undefined
          }}
          loaderProps={{
            children: <LoaderWithMsg message={message} />
          }}
        />
      </Stack>
    </Center>
  );
});

const LoaderWithMsg = memo(function LoaderWithMsg(props: { message: string }) {
  const { isLightMode } = useAppColorScheme();
  return (
    <Stack align="center" gap="md">
      <Loader />
      <Text
        ff="heading"
        fw={FONT_WEIGHT.MEDIUM}
        c={isLightMode ? 'gray.7' : 'gray.3'}
        style={{ display: 'flex', alignItems: 'center', letterSpacing: '0.04em' }}
      >
        {props.message}
        <span className="loading-dot">.</span>
        <span className="loading-dot" style={{ animationDelay: '0.2s' }}>
          .
        </span>
        <span className="loading-dot" style={{ animationDelay: '0.4s' }}>
          .
        </span>
        <style>
          {`
                    .loading-dot {
                      animation: loadingDotFade 1s infinite;
                      opacity: 0.3;
                    }
                    @keyframes loadingDotFade {
                      0%, 80%, 100% { opacity: 0.3; }
                      40% { opacity: 1; }
                    }
                  `}
        </style>
      </Text>
    </Stack>
  );
});
